import { apiInstance } from './api';

const MAX_BREADCRUMBS = 25;
const BREADCRUMBS_KEY = '__b2b_breadcrumbs__';

// Завантаження збережених крихт з sessionStorage
let breadcrumbs = [];
try {
  const saved = sessionStorage.getItem(BREADCRUMBS_KEY);
  if (saved) {
    breadcrumbs = JSON.parse(saved);
  }
} catch (_) {}

/**
 * Додає дію у масив хлібних крихт (ring buffer)
 */
export const addBreadcrumb = (category, message, extra = {}) => {
  const item = {
    timestamp: new Date().toISOString(),
    category,
    message,
    ...extra,
  };
  breadcrumbs.push(item);
  if (breadcrumbs.length > MAX_BREADCRUMBS) {
    breadcrumbs.shift();
  }
  try {
    sessionStorage.setItem(BREADCRUMBS_KEY, JSON.stringify(breadcrumbs));
  } catch (_) {}
};

/**
 * Отримує всі збережені хлібні крихти
 */
export const getBreadcrumbs = () => [...breadcrumbs];

/**
 * Відправляє лог у Strapi
 */
export const logUserAction = async ({
  action,
  level = 'info',
  message = '',
  details = {},
  storeCrmId = '',
}) => {
  try {
    const payload = {
      action,
      level,
      message,
      details: {
        ...details,
        breadcrumbs: getBreadcrumbs(),
      },
      storeCrmId,
      pageUrl: window.location.pathname + window.location.search,
    };

    // Відправляємо без авейту в UI, щоб не сповільнювати інтерфейс
    apiInstance(
      `${process.env.REACT_APP_API_URL}/api/user-action-logs`,
      'POST',
      payload
    ).catch((err) => {
      console.warn('[Logger API warn]:', err?.message || err);
    });
  } catch (err) {
    console.warn('[Logger error]:', err);
  }
};

/**
 * Глобальний слухач кліків миші
 */
const initClickTracking = () => {
  if (typeof window === 'undefined') return;

  document.addEventListener('click', (event) => {
    try {
      const target = event.target.closest('button, a, input, select, textarea, [role="button"], .ant-tabs-tab, .ant-upload');
      if (target) {
        const tag = target.tagName.toLowerCase();
        const text = (target.innerText || target.value || target.getAttribute('aria-label') || '').slice(0, 50).trim();
        const id = target.id ? `#${target.id}` : '';
        const className = target.className && typeof target.className === 'string'
          ? `.${target.className.split(/\s+/).slice(0, 2).join('.')}`
          : '';

        addBreadcrumb('ui.click', `Clicked ${tag}${id}${className}`, { text });
      }
    } catch (_) {}
  }, true);
};

/**
 * Глобальний слухач неперехоплених JS-помилок та Promise rejects
 */
const initErrorTracking = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    addBreadcrumb('error.uncaught', event.message, { stack: event.error?.stack });
    logUserAction({
      action: 'UNCAUGHT_JS_ERROR',
      level: 'error',
      message: event.message || 'Uncaught Error',
      details: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || String(event.reason || 'Unhandled Rejection');
    addBreadcrumb('error.unhandled_promise', reason);
    logUserAction({
      action: 'UNHANDLED_PROMISE_REJECTION',
      level: 'error',
      message: reason,
      details: {
        stack: event.reason?.stack,
      },
    });
  });
};

// Автоматична ініціалізація трекінгу при імпорті
initClickTracking();
initErrorTracking();
